import { Component, Vue } from 'vue-property-decorator';

@Component<LogoBar>({
  components: {
  },
})
export default class LogoBar extends Vue {

  public mounted() {
    //
  } 
}
